// extracted by mini-css-extract-plugin
module.exports = {"container":"Best_container__1GpHV","inner":"Best_inner__1GWjd","head":"Best_head__34x2q","title":"Best_title__1tMnm","slider":"Best_slider__1l8Bk","item":"Best_item__1h5XX"};